<app-reservation-table
  [dataSource]="dataSource"
  [displayedColumns]="displayedColumns"
  [totalCount]="totalCount"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [isLoading]="isLoading"
  [errorClassFn]="errorClassFn"
  [canCheckInFn]="canCheckInFn"
  [canCheckOutFn]="canCheckOutFn"
  [canCancelFn]="canCancelFn"
  [canEditFn]="canEditFn"
  [canRegisterPaymentFn]="canRegisterPaymentFn"
  (pageChange)="pageChange.emit($event)"
  (actionClick)="actionClick.emit($event)">
</app-reservation-table>
